import { createSlice } from "@reduxjs/toolkit";

const ToggleProductFilterModal = createSlice({
  name: "toggleProductFilter",
  initialState: {
    filterBy: false,
    selectLocation: false,
  },
  reducers: {
    toggleFilterBy: (state) => {
      state.filterBy = !state.filterBy;
    },
    toggleSelectLocation: (state) => {
      state.selectLocation = !state.selectLocation;
    },
    togMobileFilterFalse: (state) => {
      state.selectLocation = false;
      state.filterBy = false;
    },
  },
});

export const { toggleFilterBy, toggleSelectLocation, togMobileFilterFalse } =
  ToggleProductFilterModal.actions;
export default ToggleProductFilterModal.reducer;
